export const JOB_HOTNESS = {
	HOT: 'hot',
	NOTHOT: 'not hot',
};
